module.exports = __webpack_public_path__ + "img/img12.e4c8fcd7.png";